import React from 'react';

/** Eyebrow + heading + optional sub copy, left-aligned by default. */
export const SectionHeading = ({ eyebrow, title, sub, as: Tag = 'h2', align = 'left', testId }) => (
  <div className={`max-w-2xl ${align === 'center' ? 'mx-auto text-center' : ''}`} data-testid={testId}>
    {eyebrow && <p className="text-[11px] uppercase tracking-[0.22em] text-[var(--lux-gold)] mb-3">{eyebrow}</p>}
    <Tag className={`font-display text-white ${Tag === 'h1' ? 'text-4xl sm:text-5xl lg:text-6xl leading-[1.05]' : 'text-3xl sm:text-4xl leading-tight'}`}>{title}</Tag>
    {sub && <p className="mt-4 text-white/60 text-base sm:text-lg leading-relaxed">{sub}</p>}
  </div>
);
